(() => {
  function init(scope) {
    scope.querySelectorAll('[data-af-rio-look]').forEach(root => {
      if (root.dataset.lookReady) return;
      root.dataset.lookReady = 'true';
      const panels = [...root.querySelectorAll('[data-look-panel]')];
      const choices = [...root.querySelectorAll('[data-look-select]')];
      const events = new AbortController();
      let active = null, opener = null;
      panels.forEach(panel => {
        panel.dataset.lookFloating = '';
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'false');
        if (typeof panel.showPopover === 'function') panel.setAttribute('popover', 'manual');
      });
      choices.forEach(button => button.setAttribute('aria-haspopup', 'dialog'));
      function close(restoreFocus = false) {
        panels.forEach(panel => {
          if (panel.hasAttribute('popover') && panel.matches(':popover-open')) panel.hidePopover();
          panel.hidden = true;
        });
        choices.forEach(button => button.setAttribute('aria-expanded', 'false'));
        active = null;
        if (restoreFocus && opener?.isConnected) opener.focus({ preventScroll: true });
      }
      function position(panel, button) {
        if (window.matchMedia('(max-width: 800px)').matches) return;
        const anchor = button.getBoundingClientRect();
        const box = panel.getBoundingClientRect();
        const margin = 16, gap = 12;
        const left = Math.max(margin, Math.min(anchor.left, window.innerWidth - box.width - margin));
        const below = anchor.bottom + gap;
        const preferredTop = below + box.height <= window.innerHeight - margin ? below : anchor.top - box.height - gap;
        const top = Math.max(margin, Math.min(preferredTop, window.innerHeight - box.height - margin));
        panel.style.setProperty('--look-card-x', `${left}px`);
        panel.style.setProperty('--look-card-y', `${top}px`);
      }
      root.addEventListener('click', event => {
        const group = event.target.closest('[data-look-group-select]');
        if (group && root.contains(group)) {
          close();
          root.querySelectorAll('[data-look-group]').forEach(item => { item.hidden = item.dataset.lookGroup !== group.dataset.lookGroupSelect; });
          root.querySelectorAll('[data-look-group-select]').forEach(button => button.setAttribute('aria-pressed', String(button === group)));
          return;
        }
        const button = event.target.closest('[data-look-select]');
        if (button && root.contains(button)) {
          const id = button.dataset.lookSelect, wasOpen = id === active;
          close();
          if (wasOpen) return;
          const panel = panels.find(item => item.dataset.lookPanel === id);
          if (!panel || panel.closest('[data-look-group]')?.hidden) return;
          opener = button; active = id; panel.hidden = false;
          choices.filter(item => item.dataset.lookSelect === id).forEach(item => item.setAttribute('aria-expanded', 'true'));
          // The top layer avoids clipping by the room carousel; never scroll the page to a product.
          if (panel.hasAttribute('popover')) panel.showPopover();
          position(panel, button);
          if (event.detail === 0) panel.querySelector('a')?.focus({ preventScroll: true });
        } else if (event.target.closest('[data-look-close]')) close(true);
        else if (!event.target.closest('[data-look-panel]')) close();
      }, { signal: events.signal });
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape' && active) { event.preventDefault(); close(true); }
      }, { signal: events.signal });
      document.addEventListener('click', event => {
        if (active && !root.contains(event.target)) close();
      }, { signal: events.signal });
      document.addEventListener('scroll', event => {
        if (active && !panels.some(panel => panel.contains(event.target))) close();
      }, { capture: true, passive: true, signal: events.signal });
      window.addEventListener('resize', () => close(), { passive: true, signal: events.signal });
      const visibility = new MutationObserver(() => {
        if (root.inert || root.getAttribute('aria-hidden') === 'true') close();
      });
      visibility.observe(root, { attributes: true, attributeFilter: ['aria-hidden', 'inert'] });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) { close(); visibility.disconnect(); events.abort(); }
      }, { signal: events.signal });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
